<template>
  <form class="flex w-full overflow-x-hidden" id="form-activity" autocomplete="off" >
    <div class="w-full p-2" >
      <div class="flex flex-col items-center mb-6">
        <label
          class="block uppercase text-gray-600 text-xs font-bold mb-2 text-left"
        >Avatar</label>
        <div class="px-4 mb-6">
          <img
            alt="..."
            class="shadow rounded max-w-full h-auto align-middle border-none"
            :src="input.avatar?input.avatar:imgPlaceholder"
            style="width: 150px;"
          />
        </div>
        <div class="flex flex-col mb-2">
          <p class="text-xs text-gray-700">Minimum 900x900, Maximum 1MB</p>
        </div>
        <div class="flex flex-col mb-2" v-if="isFileLarge || ($v.input.avatar.$dirty && !$v.input.avatar.required)">
          <text-error v-if="isFileLarge" text="Please select correct file" />
          <text-error v-if="$v.input.avatar.$dirty && !$v.input.avatar.required" text="Please select channel artwork." />
        </div>
        <div class="flex">
          <Button label="Browse File" v-if="!input.avatar">
            <template v-slot:any>
              <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                     type="file"
                     name="profile_picture"
                     @change="onFileChange"
              />
            </template>
          </Button>
          <Button label="Remove" variant="default" v-if="input.avatar" @clicked="changeImage"></Button>
        </div>
      </div>
      <div class="flex flex-col items-center mb-6">
        <label
          class="block uppercase text-gray-600 text-xs font-bold mb-2 text-left"
        >Background Image</label>
        <div class="px-4 mb-6">
          <img
            alt="..."
            class="shadow rounded max-w-full h-auto align-middle border-none"
            :src="input.background_image?input.background_image:imgPlaceholder"
            style="width: 150px;"
          />
        </div>
        <div class="flex flex-col mb-2">
          <p class="text-xs text-gray-700">Maximum 1MB</p>
        </div>
        <div class="flex flex-col mb-2" v-if="isFileLargeBg || ($v.input.background_image.$dirty && !$v.input.background_image.required)">
          <text-error v-if="isFileLargeBg" text="Please select correct file" />
          <text-error v-if="$v.input.background_image.$dirty && !$v.input.background_image.required" text="Please select background image." />
        </div>
        <div class="flex">
          <Button label="Browse File" v-if="!input.background_image">
            <template v-slot:any>
              <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                     type="file"
                     name="background_image"
                     @change="onFileChangeBg"
              />
            </template>
          </Button>
          <Button label="Remove" variant="default" v-if="input.background_image" @clicked="changeImageBg"></Button>
        </div>
      </div>
      <form-item label='Channel Name'>
        <template v-slot>
          <Input
            v-model="input.name"
            placeholder="ex. Channel Name"
            :error="$v.input.name.$dirty && (!$v.input.name.required || !$v.input.name.maxLength)"
            maxlength="100"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.name.$dirty && !$v.input.name.required" text="Please fill Channel Name." />
            <text-error v-if="$v.input.name.$dirty && !$v.input.name.maxLength" text="Max length Channel name is 100 character." />
          </div>
        </template>
      </form-item>
      <form-item label='Channel Email'>
        <template v-slot>
          <Input
            v-model="input.email"
            placeholder="ex. Channel Email"
            :error="$v.input.email.$dirty && (!$v.input.email.required || !$v.input.email.email)"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.email.$dirty && !$v.input.email.required" text="Please fill Channel Email." />
            <text-error v-if="$v.input.email.$dirty && !$v.input.email.email" text="Email is not valid format." />
          </div>
        </template>
      </form-item>
      <form-item label='Country of Residence'>
        <template v-slot>
          <Select
            v-model="input.country_code"
            empty-label="All Countries"
            :error="$v.input.country_code.$dirty && (!$v.input.country_code.required)"
            :data="dataListCountry"
          />
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.country_code.$dirty && !$v.input.country_code.required" text="Please select the country." />
          </div>
        </template>
      </form-item>
      <form-item label='Channel Description'>
        <template v-slot>
          <div class="relative">
            <TextArea
              v-model="input.description"
              placeholder="Description Channel"
              :error="$v.input.description.$dirty && (!$v.input.description.required || !$v.input.description.maxLength)"
              rows="5"
            />
            <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{input.description.length}}/{{maxLengthDesc}}</div>
          </div>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.description.$dirty && !$v.input.description.required" text="Please fill the Description." />
            <text-error v-if="$v.input.description.$dirty && !$v.input.description.maxLength" text="Max length description channel is 750 character" />
          </div>
        </template>
      </form-item>
    </div>
  </form>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { maxLength, required, email } from 'vuelidate/lib/validators';
import helpersMixin from '@/mixins/helpers.mixins';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { FormItem, Input, TextArea, Button, TextError, Select } from '@/components/Layout/Form';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

const initialStateChannel = {
  id: null,
  name: '',
  email: '',
  description: '',
  country_code: null,
  avatar: null,
  background_image: null,
};

export default {
  name: 'ChannelForm',
  mixins: [validationMixin, helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    channel: {
      type: Object,
      default: rawProps => ({ ...rawProps }),
    },
  },
  data() {
    return {
      maxLengthDesc: 750,
      dragover: false,
      isFileLarge: false,
      isError: false,
      isFileLargeBg: false,
      isFileWrongFormatBg: false,
      isErrorBg: false,
      input: { ...initialStateChannel },
      dataListCountry: [],
      imgPlaceholder,
    };
  },
  validations() {
    return {
      input: {
        avatar: {
          required,
        },
        background_image: {
          required,
        },
        name: {
          required,
          maxLength: maxLength(100),
        },
        description: {
          required,
          maxLength: maxLength(750),
        },
        country_code: {
          required,
        },
        email: {
          required, email,
        },
      },
    };
  },
  computed: {
    ...mapGetters('AppSettingModule', ['listCountry']),
  },
  mounted() {},
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.resetState();
        }
      },
    },
    listCountry: {
      immediate: true,
      handler(val) {
        if (val) {
          this.dataListCountry = val.map(v => ({
            value: v.code,
            label: v.name,
          }));
        }
      },
    },
  },
  methods: {
    ...mapActions('MissionsVideosModule', [
      'requestAddChannel', 'requestEditChannel',
    ]),
    resetState() {
      this.$v.$reset();
      this.isError = false;
      this.isFileLarge = false;
      this.isErrorBg = false;
      this.isFileLargeBg = false;
      this.isFileWrongFormatBg = false;
      this.input = Object.assign({}, this.channel);
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.isFileLarge && !this.isFileLargeBg) {
        const data = { ...this.input };
        if (this.channel.avatar !== this.input.avatar) {
          data.avatar = await axios({
            method: 'get',
            url: this.input.avatar,
            responseType: 'blob',
          })
            .then(this.processFileBlob);
        } else {
          delete data.avatar;
        }
        if (this.channel.background_image !== this.input.background_image) {
          data.background_image = await axios({
            method: 'get',
            url: this.input.background_image,
            responseType: 'blob',
          })
            .then(this.processFileBlob);
        } else {
          delete data.background_image;
        }
        if (this.channel.id) {
          await this.requestEditChannel(data);
        } else {
          await this.requestAddChannel(data);
        }
        this.$emit('on-submit-channel', true);
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    onFileChange(e) {
      this.isFileLarge = false;
      const file = e.target.files[0];
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.input.avatar = URL.createObjectURL(file);
    },
    changeImage() {
      this.input.avatar = null;
    },
    onFileChangeBg(e) {
      this.isFileLargeBg = false;
      this.isFileWrongFormatBg = false;
      const file = e.target.files[0];
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLargeBg = true;
      }
      this.input.background_image = URL.createObjectURL(file);
    },
    changeImageBg() {
      this.input.background_image = null;
    },
  },
  components: { FormItem, Input, TextArea, Button, TextError, Select },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Channel/ChannelForm.vue